export * from "./MedicalCardsHistory.async";
